import React from 'react';
import {Col, InputGroup, Row, FormControl, Button, Form, Container} from "react-bootstrap";
import {Search} from '@mui/icons-material';
import {FaExchangeAlt} from 'react-icons/fa'
import styles from "./Form.module.css";

const FormInput = () => {

    const handleSubmit = (e) => {
        e.preventDefault()
    }

    return (
        <Container>
            <form onSubmit={handleSubmit}>
                <Row className='pt-4'>
                    <Col>
                        <select className={`${styles.selectOption}`}>
                            <option>Return</option>
                            <option>One Way</option>
                            <option>Multi City</option>
                        </select>
                        <select className={`${styles.selectOption}`}>
                            <option>1 Adult</option>
                            <option>2 Adult</option>
                            <option>3 Adult</option>
                        </select>
                        <select className={`${styles.selectOption}`}>
                            <option>Economy</option>
                            <option>Business</option>
                            <option>First</option>
                        </select>
                    </Col>
                </Row>
                <Row className="align-items-center">
                    <Col md={2} className="my-1">
                        <Form.Control id="inlineFormInputName" type='text' placeholder='From?'/>
                    </Col>
                    <Col md="auto" className="my-1">
                        <Button variant="outline-secondary"><FaExchangeAlt/></Button>
                    </Col>
                    <Col md={2} className="my-1">
                        <Form.Control id="inlineFormInputName" type='text' placeholder='To?'/>
                    </Col>
                    <Col md={2} className="my-1">
                        <Form.Control id="inlineFormInputName" type='date'/>
                    </Col>
                    <Col md={2} className="my-1">
                        <InputGroup>
                            <FormControl id="inlineFormInputGroupUsername" type='date'/>
                        </InputGroup>
                    </Col>
                    <Col md="auto" className="my-1">
                        <Button variant="primary" type="submit"><Search/></Button>
                    </Col>
                </Row>
            </form>
        </Container>
    );
}

export default FormInput;
